const DEFAULT_CDN_URL = 'https://cdn.appjoly.com'

function isFullUrl(url: string) {
  return url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//')
}

export function getImageUrl(path: string | undefined | null, cdnUrl?: string) {
  if (!path) {
    return ''
  }
  if (isFullUrl(path)) {
    return path
  }
  const baseUrl = cdnUrl || DEFAULT_CDN_URL
  return `${baseUrl.replace(/\/$/, '')}/${path.replace(/^\//, '')}`
}

export function getAvatarUrl(path: string | undefined | null, cdnUrl?: string) {
  const url = getImageUrl(path, cdnUrl)
  return url || undefined
}
